import { render } from "./EventsPage.vue?vue&type=template&id=6e5becea&ts=true"
import script from "./EventsPage.vue?vue&type=script&lang=ts"
export * from "./EventsPage.vue?vue&type=script&lang=ts"

import "./EventsPage.vue?vue&type=style&index=0&id=6e5becea&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__